import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lang]/components/questions/Questions.tsx");
